/**
 * Go Sport - Niveaux sportifs et ratios HIIT
 */

export const SPORT_LEVELS = [
  { level: 1, label: 'Débutant absolu', emoji: '🌱', description: 'Aucune pratique, essoufflé rapidement' },
  { level: 2, label: 'Sédentaire actif', emoji: '🚶', description: 'Marche quotidienne uniquement' },
  { level: 3, label: 'Débutant', emoji: '🏃', description: '1 à 2 séances/mois' },
  { level: 4, label: 'Régulier débutant', emoji: '💪', description: '1 séance/semaine' },
  { level: 5, label: 'Intermédiaire', emoji: '⚡', description: '2 séances/semaine, cardio de base' },
  { level: 6, label: 'Intermédiaire+', emoji: '🔥', description: '3 séances/semaine, HIIT occasionnel' },
  { level: 7, label: 'Avancé', emoji: '🏋️', description: '4+ séances/semaine, technique correcte' },
  { level: 8, label: 'Expert', emoji: '🥊', description: 'Compétitions amateurs, programmes structurés' },
  { level: 9, label: 'Athlète', emoji: '🏆', description: 'Entraînement quotidien, coach suivi' },
  { level: 10, label: 'Coach / Pro', emoji: '👑', description: 'Niveau professionnel ou coach certifié' },
];

export const HIIT_RATIOS = [
  { level: 1, work: 15, rest: 45, cycles: 4 },
  { level: 2, work: 20, rest: 40, cycles: 5 },
  { level: 3, work: 25, rest: 35, cycles: 6 },
  { level: 4, work: 30, rest: 30, cycles: 6 },
  { level: 5, work: 35, rest: 25, cycles: 7 },
  { level: 6, work: 40, rest: 20, cycles: 8 },
  { level: 7, work: 45, rest: 15, cycles: 8 },
  { level: 8, work: 50, rest: 10, cycles: 10 },
  { level: 9, work: 55, rest: 10, cycles: 12 },
  { level: 10, work: 60, rest: 10, cycles: 15 },
];

export const EVALUATION_QUESTIONS = [
  {
    id: 'frequency',
    question: 'À quelle fréquence faites-vous du sport ?',
    weight: 0.3,
    options: [
      { label: 'Jamais', value: 1 },
      { label: '1×/mois', value: 3 },
      { label: '1×/semaine', value: 5 },
      { label: '2-3×/semaine', value: 7 },
      { label: 'Quotidien', value: 10 },
    ],
  },
  {
    id: 'cardio',
    question: 'Quelle est votre capacité cardio ?',
    weight: 0.2,
    options: [
      { label: 'Essoufflé(e) en montant des escaliers', value: 1 },
      { label: 'Je cours 10 min', value: 4 },
      { label: 'Je cours 30 min', value: 7 },
      { label: 'Je cours 1h+ facilement', value: 10 },
    ],
  },
  {
    id: 'musculation',
    question: 'Expérience en musculation ?',
    weight: 0.2,
    options: [
      { label: 'Jamais touché de poids', value: 1 },
      { label: 'Quelques fois', value: 4 },
      { label: 'Régulier avec programme', value: 7 },
      { label: 'Compétition', value: 10 },
    ],
  },
  {
    id: 'flexibility',
    question: 'Comment décririez-vous votre souplesse ?',
    weight: 0,
    options: [
      { label: 'Très raide', value: 2 },
      { label: 'Moyenne', value: 5 },
      { label: 'Bonne', value: 7 },
      { label: 'Très souple', value: 10 },
    ],
  },
  {
    id: 'objective',
    question: 'Quel est votre objectif principal ?',
    weight: 0,
    options: [
      { label: 'Perdre du poids', value: 'weight_loss' },
      { label: 'Prendre du muscle', value: 'muscle' },
      { label: "Améliorer l'endurance", value: 'endurance' },
      { label: 'Bien-être général', value: 'wellbeing' },
      { label: 'Performance', value: 'performance' },
    ],
  },
  {
    id: 'time',
    question: 'Temps disponible par séance ?',
    weight: 0,
    options: [
      { label: '15 min', value: 15 },
      { label: '30 min', value: 30 },
      { label: '45 min', value: 45 },
      { label: '1h+', value: 60 },
    ],
  },
  {
    id: 'injuries',
    question: 'Blessures ou limitations ?',
    weight: 0,
    options: [
      { label: 'Aucune', value: 'none' },
      { label: 'Dos', value: 'back' },
      { label: 'Genou', value: 'knee' },
      { label: 'Épaule', value: 'shoulder' },
      { label: 'Autre', value: 'other' },
    ],
  },
  {
    id: 'selfEval',
    question: 'Comment évaluez-vous votre niveau global ?',
    weight: 0.3,
    type: 'slider',
    min: 1,
    max: 10,
  },
];

export function calculateLevel(answers) {
  let score = 0;
  let totalWeight = 0;

  for (const q of EVALUATION_QUESTIONS) {
    if (q.weight > 0 && answers[q.id] !== undefined) {
      const val = q.type === 'slider' ? answers[q.id] : answers[q.id];
      if (typeof val === 'number') {
        score += val * q.weight;
        totalWeight += q.weight;
      }
    }
  }

  if (totalWeight === 0) return 1;
  return Math.max(1, Math.min(10, Math.round(score / totalWeight)));
}

export const BODY_ZONES = [
  { id: 'full', label: 'Plein corps', emoji: '🧍' },
  { id: 'upper', label: 'Haut du corps', emoji: '💪' },
  { id: 'lower', label: 'Bas du corps', emoji: '🦵' },
  { id: 'cardio', label: 'Cardio pur', emoji: '❤️' },
];

export const SESSION_DURATIONS = [15, 20, 30, 45];
